import { formatEther } from '@ethersproject/units'
import JSBI from 'jsbi'

export function weiToEther(balance: JSBI | undefined, decimal: number): string {
  return balance ? parseFloat(formatEther(balance.toString())).toFixed(decimal) : 'Loading'
}
